import Core from '@/core/core/core';

/**
 * Получить объект Date из строки
 * @param date - строка с датой
 */
export function stringToDate(date: string) {
	if (date.indexOf('T') === -1) {
		if (date.length == 10) {
			date += ' 00:00:00';
		}

		date = date.replace(' ', 'T') + Core.state.gmt;
	}

	return new Date(date);
}

/**
 * Генерация строки с датой в формате Y-m-d H:i:s или в формате Core.state.dateFormat, если указан useFormat = true
 * @param {?number} timestamp
 * @param {?boolean} useFormat
 * @param {0|1|2|3} time - 0: только дата, 1: дата и часы, 2: дата и часы с минутами, 3: дата и часы с минутами и секундами
 */
export function genDate(timestamp: number, useFormat: boolean = true, time: 0 | 1 | 2 | 3 = 0): string {
	let date;
	if (timestamp != undefined) {
		date = new Date(timestamp);
	} else {
		date = new Date();
	}

	const Y = date.getFullYear();
	const m = String(date.getMonth() + 1).padStart(2, '0');
	const d = date.getDate().toString().padStart(2, '0');

	const H = date.getHours().toString().padStart(2, '0');
	const i = date.getMinutes().toString().padStart(2, '0');
	const s = date.getSeconds().toString().padStart(2, '0');

	date = Y + '-' + m + '-' + d;

	if (time) date += ' ';
	if (time >= 1) date += H;
	if (time >= 2) date += ':' + i;
	if (time >= 3) date += ':' + s;

	if (useFormat) {
		date = dateFormat(date, time);
	}

	return date;
}

/**
 * Перевод даты в формат пользователя
 * @param {string} date - строка в формате Y-m-d H:i:s
 * @param {0|1|2|3} time - 0: только дата, 1: дата и часы, 2: дата и часы с минутами, 3: дата и часы с минутами и секундами
 * @param {string} emptyValue - значение, которое надо вернуть, если дата не указана
 */
export function dateFormat(date: string, time: 0 | 1 | 2 | 3 = 2, emptyValue: string = Core.L.Not_date): string {
	if (!date || date.substring(0, 10) === '0000-00-00') {
		if (emptyValue && emptyValue !== '0000-00-00') {
			return emptyValue;
		}
	}

	const dateFormat = Core.state.dateFormat.toLowerCase();

	let dateForObj = date.substring(0, 10);

	if (dateForObj.length === 7) {
		dateForObj += '-01';
	}

	dateForObj += ' 00:00';

	// safari fix
	dateForObj = dateForObj.replace(/-/g, '/');

	const dateObject = new Date(dateForObj);
	if (isNaN(Number(dateObject))) {
		return emptyValue;
	}

	let result = dateFormat.
		replace('y', String(dateObject.getFullYear()).padStart(2, '0')).
		replace('m', String(dateObject.getMonth() + 1).padStart(2, '0')).
		replace('d', String(dateObject.getDate()).padStart(2, '0'));

	if (date.length > 10) {
		switch (time) {
			// часы
			case 1:
				result += ' ' + date.substring(11, 13);

				break;

			// часы и минуты
			case 2:
				result += ' ' + date.substring(11, 16);

				break;

			// часы, минуты и секунды
			case 3:
				result += ' ' + date.substring(11, 19);

				break;
		}
	}

	return result;
}

/**
 * Перевод даты из формата пользователя в системный формат
 * @param {string} date - строка в формате Y-m-d H:i:s
 * @param {string} emptyValue - значение, которое надо вернуть, если дата не указана
 */
export function dateUnformat(date: string, emptyValue: string = Core.L.Not_date): string {
	if (!date) {
		return emptyValue;
	}

	if (date.match(/\d\d\d\d-\d\d-\d\d/)) {
		return date;
	}

	const dateFormat = Core.state.dateFormat.toLowerCase();

	const dateChunks = date.split(/\W/);
	const dateFormatChunks = dateFormat.split(/\W/);

	let d = '';
	let m = '';
	let y = '';

	dateFormatChunks.forEach((type, index) => {
		switch (type) {
			case 'd':
				d = dateChunks[index];

				break;
			case 'm':
				m = dateChunks[index];

				break;
			case 'y':
				y = dateChunks[index];

				break;
		}
	});

	let result = y + '-' + m + '-' + d;

	if (!result.match(/\d\d\d\d-\d\d-\d\d/)) {
		console.info('Неверный формат даты, будет возращена текущая дата, ' + result);

		result = genDate((new Date()).getTime(), false).substring(0, 10);
	}

	return result;
}
